import { render } from "./ModalTrajectory.vue?vue&type=template&id=fddb8e28"
import script from "./ModalTrajectory.vue?vue&type=script&lang=js"
export * from "./ModalTrajectory.vue?vue&type=script&lang=js"

import "./ModalTrajectory.vue?vue&type=style&index=0&id=fddb8e28&lang=css"
script.render = render

export default script